<template>
    <div class="video-modal">
        <div class="content">
            <div class="box">
                <div @click="hideModal()" class="close"></div>
                <iframe :src="'https://www.youtube.com/embed/'+ $store.state.videoModalSrc" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
        </div>
    </div>
</template>

<script>
    import store from '../store/store';
    export default {
        name: 'video-modal',
        data() {
            return {}
        },
        methods: {
            hideModal: function() {
                store.commit('CLOSE_VIDEO_MODAL', null);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// VideoModal.vue?66e715c4